import { bff, createBFFHandlers } from '~/framework/bff';
import { getServerSideMonolithClient } from '~/framework';
import { getBulletStyles, BulletStyle } from '~/monolith-api';

export { getBulletStyles };

export type { BulletStyle };

export default createBFFHandlers({
   get: async (req, res) => {
      const monolithClient = getServerSideMonolithClient(req);
      const result = await getBulletStyles({ apiClient: monolithClient });
      res.status(200).json(result);
   },
});

export const getBulletStylesFromClient = (): ReturnType<typeof getBulletStyles> => {
   return bff()
      .get('/bullet-styles/getBulletStyles')
      .then(response => response.data);
};
